import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";

class RadioButtonProps extends BaseProps {
  label: String;
  isActive: Boolean;
  onClick: Function;
}

export const RadioButton = observer((props: RadioButtonProps) => {
  const containerProps = {
    className: ['radio-button', props.isActive ? 'active-radio-button' : ''].join(' '),
    onClick: () => props.onClick()
  }

  return (
    <div {...containerProps}>
      <div className={'radio-button-bubble'}>
        {
          props.isActive && <div className={'active-radio-button-fill'}/>
        }
      </div>
      <div>{props.label}</div>
    </div>
  )
});
